<template>
	<div>
		<el-form ref="defForm" :rules="rules" :model="defForm" label-width="80px">
			<el-form-item label="岗位名称" prop="name">
				<el-input v-model="defForm.name"></el-input>
			</el-form-item>
			<el-form-item label="招聘人数" prop="quantity">
				<el-input-number v-model="defForm.quantity" />
			</el-form-item>
			<el-form-item label="学历要求" prop="degree">
				<el-select v-model="defForm.degree" placeholder="请选择栏目类型"> 
					<el-option v-for="(item,index) in this.degreeList" :key="index" :label="item.label" :value="item.label">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="工作地点" prop="workplace">
				<el-input v-model="defForm.workplace"></el-input>
			</el-form-item>
			<el-form-item label="薪资待遇" prop="treatment">
				<el-input type="textarea" autosize v-model="defForm.treatment"></el-input>
			</el-form-item>
			<el-form-item label="招聘要求" prop="request">
				<el-input type="textarea" autosize v-model="defForm.request"></el-input>
			</el-form-item>
			<el-form-item label="工作内容" prop="content">
				<el-input type="textarea" autosize v-model="defForm.content"></el-input>
			</el-form-item>
			<el-form-item size="large">
				<el-button type="primary" @click="close">取消</el-button>
				<el-button type="primary" :loading="loading" @click="submitForm">保存</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	import {update} from '@/api/recruit'
	import token from '@/token.js'
	export default {
		name: "Edit",
		props: ['data'],
		data() {
			return {
				defForm: {
					id: 0,
					typeId: 0,
					name: '',
					quantity: 0,
					degree:'',
					workplace: '',
					treatment: '',
					request: '',
					content: '',
					updateUserID: token.getUser().id,
					updateUserName: token.getUser().manager_username
				},
				degreeList:[
					{label:'高中'},
					{label:'专科'},
					{label:'本科'},
					{label:'硕士'}
				],
				loading: false,
				rules: {
					name: [{
						required: true,
						message: '必填项不能为空'
					}],
				}
			}
		},
		created() {
			let editItem=JSON.parse(JSON.stringify(this.data))
			this.defForm.id = editItem.id
			this.defForm.name = editItem.name
			this.defForm.quantity = editItem.quantity
			this.defForm.degree = editItem.degree
			this.defForm.workplace = editItem.workplace
			this.defForm.treatment = editItem.treatment
			this.defForm.request = editItem.request
			this.defForm.content = editItem.content
			
		},
		methods: {
			submitForm() {
				this.$refs['defForm'].validate(valid => {
					if (valid) {
						this.loading = true
						console.log("编辑",this.defForm)
						update(this.defForm).then(data => {
							this.loading = false
							this.$message.success("招聘岗位["+this.defForm.name+"]编辑成功!")
							this.$refs['defForm'].resetFields()
							this.$emit("after")
							this.$emit("hideDialog")
						}).catch(error => {
							this.loading = false
							this.$message.error(error)
						})
					}
				})
			},
			close() {
				this.$emit("hideDialog")
			}
		}
	}
</script>

<style scoped>
	.left{
		width: 50%;
		display: inline-block;
	}
	.right{
		width: 50%;
		display: inline-block;
	}
	.avatar-uploader {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		width: 80px;
		height: 80px;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 80px;
		height: 80px;
		line-height: 80px;
		text-align: center;
	}

	.avatar {
		width: 80px;
		height: 80px;
		display: block;
	}
</style>
